import { colors } from '../../colors';
var pencilBanner = {
  bgColor: colors.equineSnow,
  textColor: colors.equineStone,
  textColorDark: colors.equineIron,
  textColorLight: colors.equineSnow
};
export default pencilBanner;